<template>
  <div class="cover-empty">
    <router-view></router-view>
    <div class="text-center mt-4">
      <LanguageSwitcher class="d-inline-block mr-2" />
    </div>
    <div style="position: absolute; bottom: 30px; left: 30px; cursor: pointer" @click.prevent="openNeuro">
      <img width="120" height="24" :src="`${publicPath}${imgLogoNSName}`" />
    </div>
    <div
      style="bottom: 30px; right: 30px; cursor: pointer; color: white; font-weight: 300;"
      class="position-absolute link-underline"
      @click.prevent="openPolicy"
    >
      {{ $t('src/pages/login.privacy') }}
    </div>
  </div>
</template>

<script>
require('@/styles/pages/empty-layout.less')

export default {
  name: 'LayoutEmpty',
  components: {
    LanguageSwitcher: () => import('@/components/LanguageSwitcher.vue')
  },
  data: () => ({
    publicPath: process.env.BASE_URL
  }),
  computed: {
    localeRU() {
      if (this.$i18n.locale === 'ru') {
        return true
      } else return false
    },
    imgLogoNSName() {
      return this.localeRU ? 'logo_ns_rus_white.svg' : 'logo_ns_eng_white.svg'
    }
  },
  methods: {
    openNeuro() {
      window.open('https://neurosoft.com/ru/contacts', '_blank')
    },
    openPolicy() {
      window.open(
        'https://neurosoft.com/files/documents/commonfile/politika-v-otnoshenii-obrabotki-i-zaschity-pdn.pdf',
        '_blank'
      )
    }
  }
}
</script>
